export function formatEnumerated(intl, prefix, suffix, data = {}) {
  const defaultMessage = "unknown";
  let message = intl.formatMessage({id: `${prefix}.${suffix}`, defaultMessage}, data);
  if (message === defaultMessage) {
    message = intl.formatMessage({id: `${prefix}.unknown`}, data);
  }

  return message;
}
